module.exports = __webpack_public_path__ + "img/weixin.ad61494c.png";